import type { OrchestrationThread, ThreadHistoryEditedPayload } from "@cleo/contracts";
export { parseWorldOriginalMemberId } from "./conversationOriginalArchive.ts";
export * from "./conversationCapturedPassage.ts";
export function applyConversationHistoryEdit(
  thread: OrchestrationThread,
  edit: ThreadHistoryEditedPayload,
): OrchestrationThread {
  const messages = new Set(edit.removedMessageIds),
    turns = new Set(edit.removedTurnIds);
  const retained = thread.messages.filter((m) => !messages.has(m.id));
  if (edit.summaryMessage) retained.push(edit.summaryMessage);
  retained.sort((a, b) => a.createdAt.localeCompare(b.createdAt) || a.id.localeCompare(b.id));
  return {
    ...thread,
    messages: retained,
    historyRevision: edit.historyRevision,
    activities: thread.activities.filter((a) => a.turnId === null || !turns.has(a.turnId)),
    proposedPlans: thread.proposedPlans.filter((p) => p.turnId === null || !turns.has(p.turnId)),
    checkpoints: thread.checkpoints.filter((c) => !turns.has(c.turnId)),
    latestTurn: thread.latestTurn && turns.has(thread.latestTurn.turnId) ? null : thread.latestTurn,
  };
}

export const conversationOriginalMemberId = (threadId: string, revision: string) =>
  `local-history:${encodeURIComponent(threadId)}/${encodeURIComponent(revision)}`;

export function parseConversationOriginalMemberId(memberId: string) {
  const match = /^local-history:([^/]+)\/([^/]+)(?:\/(?:index\/(\d+)|(\d+)))?$/u.exec(memberId);
  if (!match) return null;
  try {
    const threadId = decodeURIComponent(match[1]!);
    const revision = decodeURIComponent(match[2]!);
    if (
      !threadId ||
      !revision ||
      conversationOriginalMemberId(threadId, revision) !== `local-history:${match[1]}/${match[2]}`
    )
      return null;
    const ordinal = match[4] === undefined ? null : Number(match[4]);
    const indexStart = Number(match[3] ?? 0);
    if ((ordinal !== null && !Number.isSafeInteger(ordinal)) || !Number.isSafeInteger(indexStart))
      return null;
    return { threadId, revision, ordinal, indexStart, indexPage: match[3] !== undefined };
  } catch {
    return null;
  }
}
